<template>
  <div class="d-flex align-items-center gap-4 fondo-terciario rounded-4 p-3 px-4 sombra-sm mb-4">
    <div class="card-body w-100">
      <div class="d-flex align-items-center justify-content-between" @click="toggleExpanded" style="cursor: pointer;">
        <h2 class="fw-bold fs-5 m-0">{{$t('idsInternosYExternos')}}</h2>
        <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :style="{ transform: isExpanded ? 'scaleY(1)' : 'scaleY(-1)' }">
          <path d="M5.70711 9.71069C5.31658 10.1012 5.31658 10.7344 5.70711 11.1249L10.5993 16.0123C11.3805 16.7927 12.6463 16.7924 13.4271 16.0117L18.3174 11.1213C18.708 10.7308 18.708 10.0976 18.3174 9.70708C17.9269 9.31655 17.2937 9.31655 16.9032 9.70708L12.7176 13.8927C12.3271 14.2833 11.6939 14.2832 11.3034 13.8927L7.12132 9.71069C6.7308 9.32016 6.09763 9.32016 5.70711 9.71069Z" class="fill-principal"/>
        </svg>
      </div>
      <div v-if="isExpanded" class="mt-3">
        <div class="mb-3 d-flex flex-column">
          <label class="m-0 texto-secundario fs-7">IdPersona</label>
          <p class="m-0">{{ persona.IdPersona || 'N/A' }}</p>
        </div>
        <div class="mb-3 d-flex flex-column">
          <label class="m-0 texto-secundario fs-7">FiduUserId</label>
          <p class="m-0">{{ persona.FiduUserId || 'N/A' }}</p>
        </div>
        <div class="mb-3 d-flex flex-column">
          <label class="m-0 texto-secundario fs-7">SiglaUntis</label>
          <p class="m-0">{{ persona.SiglaUntis || 'N/A' }}</p>
        </div>
        <div class="d-flex flex-column">
          <label class="m-0 texto-secundario fs-7">NroColegium</label>
          <div v-if="persona?.PersonasRoles?.filter( pr => pr?.NroColegium != null) && persona.PersonasRoles.filter( pr => pr?.NroColegium != null).length > 0">
            <p v-for="rol in persona.PersonasRoles.filter( pr => pr?.NroColegium != null)" :key="rol.IdRol" class="m-0">{{ rol?.NroColegium || 'N/A' }}</p>
          </div>
          <p v-else class="m-0">N/A</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'IdsSection',
  props: {
    persona: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const isExpanded = ref(false);

    const toggleExpanded = () => {
      isExpanded.value = !isExpanded.value;
    };

    onMounted(() => {
      console.log('IdsSection mounted, persona:', props.persona);
      if (props.persona) {
        console.log('PersonasRoles:', props.persona.PersonasRoles);
        console.log('Filtered roles:', props.persona.PersonasRoles?.filter(pr => pr?.NroColegium != null));
      }
    });

    return {
      isExpanded,
      toggleExpanded
    };
  }
};
</script>

<style>
</style>